import styled from 'styled-components';
import { colors } from 'shared/theme';

export const Container = styled.div`
  background-color: ${colors.appBackground};
`;
